/* eslint-disable */
'use strict';

const Header = {
    init: function() {
        this.headerScroll();

        const promoBar = document.querySelector('.promo-bar');

        if (promoBar) {
            this.handlePromoBarVisibility(promoBar);
            this.promoBarTextSwitch();
            this.promoBarClose();
        }

        this.megaMenuLinks();
        this.sideMegaMenu();
        this.headerSearch();

        if (window.innerWidth < 1200) {
            const headerPhone = document.querySelector('.js-site-header__nav-link--phone');
            if(headerPhone) {
                this.appendPhoneOnResponsiveSideMegamenu();
            }
        }
    },


    handlePromoBarVisibility: (promoBar)=>{
        const storedValue = window.sessionStorage.getItem('promoClosed');
        if(storedValue){
            if(storedValue === "true"){
                if(promoBar){
                    promoBar.style.display = "none";
                }
            }
        }
    },

    headerScroll: function () {
		document.addEventListener('scroll', function () {
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			const domHeader = document.querySelector('.header-main');

			if (scrollTop > 20) {
				domHeader.classList.add('is-sticky');
			} else {
				domHeader.classList.remove('is-sticky');
			}
		});
	},

    promoBarTextSwitch: function() {
        const texts = document.querySelectorAll('.promo-bar__text');
        let currentIndex = 0;

        texts[currentIndex].classList.add('active');

        setInterval(() => {
            texts.forEach(text => text.classList.remove('active'));
            texts[currentIndex].classList.add('active');
            currentIndex = (currentIndex + 1) % texts.length;
        }, 3000);
    },

    megaMenuLinks: function() {
        const lists = document.querySelectorAll('.mega-menu__left-column-lists');
        lists.forEach(list => {
            const items = Array.from(list.children);
            const column1 = document.createElement('ul');
            const column2 = document.createElement('ul');

            column1.classList.add('mega-menu__left-column-lists-ul');
            column2.classList.add('mega-menu__left-column-lists-ul');

            items.forEach((item, index) => {
                if (index < 5) {
                    column1.appendChild(item);
                } else {
                    column2.appendChild(item);
                }
            });
            list.appendChild(column1);
            list.appendChild(column2);
        });
    },

    sideMegaMenu: function() {
        const body = document.querySelector('body');
        const html = document.querySelector('html');
        const hamburgerBtn = document.querySelector('.js-hamburger');
        const menu = document.querySelector('.js-site-header__hamburger-menu');
        const menuInner = document.querySelector('.js-site-header__hamburger-menu-inner');
        const menuMainIconClose = document.querySelector('.js-site-header__hamburger-menu-inner-close');
        const menuLinkHasMenu = document.querySelector('.js-site-header__hamburger-menu-inner-top-link--has-menu');
        const subMenu = document.querySelector('.js-site-header__hamburger-menu-sub-menu');
        const menuLinkHasMenuCloseIcon = document.querySelector('.js-site-header__hamburger-menu-sub-menu-top-close');
        const menuLinkHasMenuBackIcon = document.querySelector('.js-site-header__hamburger-menu-sub-menu-top-back');

        hamburgerBtn.addEventListener('click', function() {
            menu.classList.add('is-visible');
            body.classList.add('prevent-scroll');
            html.classList.add('prevent-scroll');
        });

        menuMainIconClose.addEventListener('click', function() {
            menu.classList.remove('is-visible');
            body.classList.remove('prevent-scroll');
            html.classList.remove('prevent-scroll');
        });

        menuLinkHasMenu.addEventListener('click', function() {
            subMenu.classList.add('is-visible');
        });

        menuLinkHasMenuBackIcon.addEventListener('click', function() {
            subMenu.classList.remove('is-visible');
        });

        menuLinkHasMenuCloseIcon.addEventListener('click', function() {
            menu.classList.remove('is-visible');
            subMenu.classList.remove('is-visible');
            body.classList.remove('prevent-scroll');
            html.classList.remove('prevent-scroll');
        });

        menu.addEventListener('click', function(event) {
            if (!menuInner.contains(event.target) && !subMenu.contains(event.target)) {
                menu.classList.remove('is-visible');
                body.classList.remove('prevent-scroll');
                html.classList.remove('prevent-scroll');
            }
        });
    },

    appendPhoneOnResponsiveSideMegamenu: function() {
        const headerPhone = document.querySelector('.js-site-header__nav-link--phone');
        const sideMenuBottom = document.querySelector('.js-site-header__hamburger-menu-inner-bottom');
        if(headerPhone && sideMenuBottom)
            sideMenuBottom.appendChild(headerPhone);
    }, 

    promoBarClose: function() {
        const headerMain = document.querySelector('.header-main');
        const promoBar = document.querySelector('.js-promo-bar');
        const promoBarCloseIcon = document.querySelector('.js-promo-bar-close');

        promoBarCloseIcon.addEventListener('click', function() {
            promoBar.classList.add('is-hidden');
            headerMain.classList.add('no-promo-bar');
            window.sessionStorage.setItem('promoClosed', 'true');


            Header.handleProgressBar();
        });
    },

    handleProgressBar: function() {
        const progressBar = document.querySelector('.progress-bar');
        const progressBarFill = document.querySelector('.progress-bar-fill');
        const blogArticleRight = document.querySelector('.blog-article__right');
        let header = document.querySelector('header');

        const storedValue = window.sessionStorage.getItem('promoClosed');
        if(storedValue){
            if(storedValue === "true"){
                header = document.querySelector('.site-header');
            }
        }        
        let headerHeight = header.offsetHeight;
        let articleStart = blogArticleRight.offsetTop - headerHeight + 500;
        let articleEnd = blogArticleRight.offsetTop + blogArticleRight.scrollHeight - window.innerHeight + 200;

        function updateProgressBar() {
            const scrollTop = window.scrollY;           
            if (scrollTop > 2 && scrollTop >= articleStart && scrollTop <= articleEnd) {
                const maxScroll = blogArticleRight.scrollHeight - window.innerHeight + headerHeight;
                const progress = (scrollTop - articleStart) / maxScroll;
                progressBarFill.style.width = (progress * 100) + '%';
            }
        }
 
        function onScroll() {
            const scrollTop = window.scrollY;

            if (scrollTop > 2 && scrollTop >= articleStart && scrollTop <= articleEnd) {
                progressBar.style.display = 'block';
                progressBar.style.top = headerHeight + 'px';
            } else {
                progressBar.style.display = 'none';
            }

            updateProgressBar();
        }

        window.addEventListener('scroll', onScroll);
        window.addEventListener('resize', function() {
            headerHeight = header.offsetHeight;
            articleStart = blogArticleRight.offsetTop - headerHeight;
            articleEnd = blogArticleRight.offsetTop + blogArticleRight.scrollHeight - window.innerHeight;
            updateProgressBar();
        });

        onScroll();
    },

    headerSearch: function() {
        const body = document.querySelector('body');
        const html = document.querySelector('html');
        const searchBtn = document.querySelector('.js-site-header__nav-icon-search');
        const searchHolder = document.querySelector('.js-site-header__search');
        const searchInner = document.querySelector('.js-site-header__search-inner');
        const searchIconClose = document.querySelector('.js-site-header__search-close');
        const searchInput = document.getElementById("site-header_search-input");
        const removeBtn = document.querySelector('.site-header__search-inner-top-remove');
        const mostSearcheditems = document.querySelector('.site-header__search-inner-top-search-terms');

        removeBtn.addEventListener('click',()=>{
            this.clearInputValue(searchInput);

            removeBtn.classList.remove('is-visible');
            mostSearcheditems.classList.add('is-visible');
        })
        searchBtn.addEventListener('click', ()=> {
            mostSearcheditems.classList.add('is-visible');
            removeBtn.classList.remove('is-visible');

            this.clearInputValue(searchInput);

            searchHolder.classList.add('is-visible');
            body.classList.add('prevent-scroll');
            html.classList.add('prevent-scroll');
        });

        searchIconClose.addEventListener('click', function() {
            searchHolder.classList.remove('is-visible');
            body.classList.remove('prevent-scroll');
            html.classList.remove('prevent-scroll');
        });

        searchHolder.addEventListener('click', function(event) {
            if (!searchInner.contains(event.target)) {
                searchHolder.classList.remove('is-visible');
                body.classList.remove('prevent-scroll');
                html.classList.remove('prevent-scroll');
            }
        });

        this.hoverOver(searchInput);
    },

    clearInputValue: function(inputElement) {
        inputElement.value = '';
        let event = new Event('change', {
            'bubbles': true,
            'cancelable': true
        });
        inputElement.dispatchEvent(event);
    },
    hoverOver: function(inputElement) {
        const topSearchElements = document.querySelectorAll('.site-header__search-inner-top-search-terms-link');

        topSearchElements.forEach((hoverItem) => {
            hoverItem.addEventListener('mouseover', () => {
                inputElement.value = hoverItem.textContent;
            });

            hoverItem.addEventListener('mouseout', () => {
                inputElement.value = '';
            });
        });
    },
};

export default Header;
